import { createAction } from '@reduxjs/toolkit';
import { GET_FISCAL_CODE_SUCCESS, GET_FISCAL_CODE_REQUEST, SET_IS_EINVOICE_SHOWED, GET_CITIES_REQUEST, GET_CITIES_SUCCESS, CLEAR_INVOICE_CITIES, SET_EINVOICE_ENABLE_PARAM, } from './actionTypes';
const getFiscalCodeRequest = createAction(GET_FISCAL_CODE_REQUEST);
export const getFiscalCodeSuccess = createAction(GET_FISCAL_CODE_SUCCESS);
export const setIsEInvoiceShowed = createAction(SET_IS_EINVOICE_SHOWED);
export const getCitiesRequest = createAction(GET_CITIES_REQUEST);
export const getCitiesSuccess = createAction(GET_CITIES_SUCCESS);
export const clearInvoiceCities = createAction(CLEAR_INVOICE_CITIES);
export const setEInvoiceEnableParam = createAction(SET_EINVOICE_ENABLE_PARAM);
export const actions = {
    setIsEInvoiceShowed,
    getFiscalCodeRequest,
    getFiscalCodeSuccess,
    getCitiesRequest,
    getCitiesSuccess,
    clearInvoiceCities,
    setEInvoiceEnableParam,
};
